import TemplateView from "../../../../TemplateView"
import GroupItem, {Type} from './GroupItem'
import messageResource from "../../../../messageResource";

export default class ManageGroupsButton extends TemplateView {

    constructor({
        onButtonClick = () => {},
    }) {
        super()

        this.onButtonClick = onButtonClick

        this.state = {
            isUGREnabled: false,
            isTZGEnabled: false,
        }

        this.onStateChanged(() => {
            const bothGroupsEnabled = this.state.isTZGEnabled && this.state.isUGREnabled
            this.$el.empty()
            this.$el.toggleClass('bothGroups', bothGroupsEnabled)
            if (bothGroupsEnabled) {
                this.$el.text(messageResource.getMessage('userlist.manage_groups'))
            } else if (this.state.isUGREnabled) {
                new GroupItem({
                    type: Type.DEPARTMENT,
                }).init(this.$el)
            } else {
                new GroupItem({
                    type: Type.TIME_ZONE_GROUP,
                }).init(this.$el)
            }
        })
    }

    templateHtml() {
        return "<div class='userList_manageButtons_component_manageGroupsButton'></div>"
    }

    afterRender() {
        this.$el.on('click', this.onButtonClick)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/ManageGroupsButton.js